import { post } from '@helpcenter/ajax';
import { getMeta } from '@helpcenter/meta';
import { contextPath } from '@atlassian/help-center-common-util/history';

export interface MultiServicePickerOption {
	label: string;
	value: string;
}

interface ServicesResponse {
	services: MultiServicePickerOption[];
	hasNextPage: boolean;
	endCursor: string | null;
}

interface GraphQLResponse {
	data: {
		devOpsServices: {
			nodes: { id: string; name: string; description: string }[];
			pageInfo: {
				endCursor: string | null;
				hasNextPage: boolean;
			};
		};
	};
}

export const GET_SERVICES = `
    query GetServices($cloudId: String!, $nameContains: String!, $first: Int!, $after: String) {
        devOpsServices(cloudId: $cloudId, filter: { nameContains: $nameContains }, first: $first, after: $after) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;

const pageLimit = 20;

export const fetchServices = async (
	inputValue: string,
	after?: string | null,
): Promise<ServicesResponse> =>
	post(
		`${contextPath}/gateway/api/graphql`,
		JSON.stringify({
			query: GET_SERVICES,
			variables: {
				after,
				cloudId: getMeta('tenant-id'),
				nameContains: inputValue,
				first: pageLimit,
			},
		}),
		{ 'Content-Type': 'application/json' },
	)
		.map(({ response }) => {
			// Suppressing existing violation. Please fix this.
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			const res: GraphQLResponse = response;

			const {
				data: {
					devOpsServices: {
						nodes,
						pageInfo: { hasNextPage, endCursor },
					},
				},
			} = res;
			return {
				hasNextPage,
				endCursor,
				services: nodes.map(({ id, name }) => ({
					label: name,
					value: id,
				})),
			};
		})
		.toPromise();
